module.exports = __webpack_public_path__ + "static/media/hall-P1.24d6e905.svg";